import $ from 'jquery';
import { event } from 'linksoft';
import { dispatchAction } from 'linksoft';
import actions from './profile/actions';

export default function () {
    $('#curvePointsGrid').each(function () {
        // inline edit / curvePointsGrid
        event.off('linksoft.datatables.changesSaved', handleChangesSaved);
        event.on('linksoft.datatables.changesSaved', handleChangesSaved);

        // delete action / curvePointsGrid
        event.off('siisel.datatable.updated.curvePointsGrid', handleChangesSaved);
        event.on('siisel.datatable.updated.curvePointsGrid', handleChangesSaved);
    });

    $('#nominalPointsGrid').each(function () {
        // inline edit / nominalPointsGrid
        event.off('linksoft.datatables.changesSaved', handleChangesSaved);
        event.on('linksoft.datatables.changesSaved', handleChangesSaved);

        // delete action / nominalPointsGrid
        event.off('siisel.datatable.updated.nominalPointsGrid', handleChangesSaved);
        event.on('siisel.datatable.updated.nominalPointsGrid', handleChangesSaved);
    });

    // new entities
    $(document).off('siisel.nominalPointsUpdated', handleChangesSaved);
    $(document).on('siisel.nominalPointsUpdated', handleChangesSaved);
    $(document).off('siisel.curvePointsUpdated', handleChangesSaved);
    $(document).on('siisel.curvePointsUpdated', handleChangesSaved);
}

function handleChangesSaved(data) {
    dispatchAction(actions.refreshData());
};


// WEBPACK FOOTER //
// ./App/components/modules/nominalProfileDataRefresh.js